import { useState } from "react";
import { Banknote, Link2, Package, Radio } from "lucide-react";
import { ConexaoTab, CatalogoTab, EventosTab, FinanceiroTab } from "../features/ifood/config";

const TABS = [
  { id: "conexao", label: "Conexão", icon: Link2 },
  { id: "catalogo", label: "Cardápio", icon: Package },
  { id: "financeiro", label: "Financeiro", icon: Banknote },
  { id: "eventos", label: "Eventos", icon: Radio },
];

/** Configurações → Sistema → Integração → iFood (e /vendas/ifood).
 *  `embedded` = dentro da aba Integração, que já desenha o cabeçalho com a logo —
 *  aqui não repete. Sozinha (rota /vendas/ifood) mostra o cabeçalho com a logo. */
export default function IFoodConfig({ embedded = false }) {
  const [activeTab, setActiveTab] = useState("conexao");

  return (
    <div className="h-full flex flex-col">
      {!embedded && (
        <div className="flex items-center gap-3 p-4 border-b bg-card">
          <img src="/logo-ifood.png" alt="iFood" className="w-10 h-10 rounded-lg object-contain" />
          <div>
            <h1 className="text-xl font-bold">iFood</h1>
            <p className="text-sm text-muted-foreground">Receba os pedidos do iFood direto no sistema</p>
          </div>
        </div>
      )}
      <div className={`border-b ${embedded ? "" : "bg-card px-4"}`}>
        <div className="flex gap-1 overflow-x-auto">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const active = activeTab === tab.id;
            return (
              <button key={tab.id} onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-3 font-medium text-sm border-b-2 transition-colors whitespace-nowrap ${active ? "border-red-500 text-red-600" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
                <span className="flex items-center gap-2"><Icon className="w-4 h-4" />{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>
      <div className={`flex-1 overflow-auto ${embedded ? "pt-5" : "p-6"}`}>
        {activeTab === "conexao" && <ConexaoTab />}
        {activeTab === "catalogo" && <CatalogoTab />}
        {activeTab === "financeiro" && <FinanceiroTab />}
        {activeTab === "eventos" && <EventosTab />}
      </div>
    </div>
  );
}
